import { lazyLoadView } from '@router/helpers';

export default [
  {
    path: '/:operator/:id(\\d+)/item',
    name: 'item',
    component: () => lazyLoadView(import('@views/admin/item/List.vue')),
    meta: {
      title: 'Item',
    },
  },
  {
    path: '/:operator/:id(\\d+)/item/:item_id(\\d+)',
    name: 'item-detil',
    component: () => lazyLoadView(import('@views/admin/item/Detail.vue')),
    meta: {
      title: 'Profil Item',
    },
  },
];
